export const PAYPAL_PROD_CLIENT_ID =
  'AQUolB5X1HACW19AGVFANA1SuuJOArLYtyJ0zI2yvD1jVxgUhZbl4E-m4ry_emlAEsik3xm4gcvKKL_B';
export const PAYPAL_LLC_CLIENT_ID =
  'Ae1MUYZzlsnO9ypo_0n_uCOQSLoJgEVBKfL5rkm-jLR5YNvsW9xCTJ6g4Vi4xqdXTRdYftzSoBCr5JJN';
